import { useNavigate, useParams } from '@tanstack/react-router';
import { Button } from '@tempo-io/sui-button';
import { useTranslation } from 'react-i18next';
import { useViewSurfacePaths } from '@/features/views/hooks/useViewSurfacePaths';

export const TimelineNoItemsWithDates = () => {
  const { t } = useTranslation();
  const { isMergedPortfolio } = useViewSurfacePaths();
  const { org, loopId, viewId } = useParams({ strict: false });
  const navigate = useNavigate();
  const canNavigateToTable =
    typeof org === 'string' && typeof loopId === 'number' && typeof viewId === 'number';
  return (
    <div className="flex flex-col w-full items-center gap-4 py-8">
      <div data-testid="timeline-no-items-label" className="text-xl font-bold">
        {t(($) => $.views.timeline.emptyStates.noItemsWithDates.label)}
      </div>
      <div data-testid="timeline-no-items-description" className="mb-2 text-text-neutral-secondary">
        {t(($) =>
          isMergedPortfolio
            ? $.views.roadmap.emptyStates.noItemsWithDates.description
            : $.views.timeline.emptyStates.noItemsWithDates.description,
        )}
      </div>
      {canNavigateToTable && (
        <Button
          onClick={() =>
            navigate({
              to: '/org/$org/loop/$loopId/visualizations/view/$viewId/table',
              params: { org, loopId, viewId },
            })
          }
        >
          {t(($) => $.views.timeline.emptyStates.noItemsWithDates.buttonLabel)}
        </Button>
      )}
    </div>
  );
};
